import { render, staticRenderFns } from "./_productsFeatured.vue?vue&type=template&id=d9f8cbfe&"
import script from "./_productsFeatured.vue?vue&type=script&lang=js&"
export * from "./_productsFeatured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports